<!-- results-table.component.html -->
<h1 mat-dialog-title></h1>
<div mat-dialog-content fxLayout="column">

  <div fxLayout="column" fxFlex="100" class="print">
      <div fxLayout="row" class="p-20">

        <div fxFlex fxLayout="row">
            <div fxFlex="50"><strong>{{organizacion}}</strong></div>
            <div fxFlex="50" fxLayout="column">
                            <div fxFlex fxLayoutAlign="end start">
                <img class="logo-icon" src="assets/images/logos/logo_RIC_horizontal_transparente.png" height="67" width="200" >
              </div>
              <div fxFlex fxLayoutAlign="end start" style="margin-right:20px">
                {{fecha | date:'dd/MM/yyyy'}}
              </div>
        </div>
      </div>
  </div>

  <h1 class="p-20"><strong>Debida diligencia</strong></h1>

  <div fxLayout="column" class="p-20">

    <div fxFlex fxLayout="row" class="p-10">
        <div fxFlex="70"><strong>Nombre: </strong>{{this.debidaDiligencia?.nombre}}</div>
        <div fxFlex="30"><strong>Responsable: </strong>{{this.debidaDiligencia?.responsable?.nombreCompleto}}</div>
    </div>
    <div fxFlex fxLayout="row" class="p-10">
        <div fxFlex="70"><strong>Marco de referencia: </strong>{{this.debidaDiligencia?.formulario?.nombre}}</div>
        <div fxFlex="30"><strong>Tabla de Evaluación: </strong>{{this.debidaDiligencia?.formulario?.nombre}}</div>
    </div>
    <div fxFlex fxLayout="row" class="p-10">
        <div fxFlex="70"><strong>Creado por: </strong>{{this.debidaDiligencia?.remitente?.nombreCompleto}}</div>
        <div fxFlex="30"><strong>Fecha fin: </strong>{{this.debidaDiligencia?.fechaVencimiento | date:'dd/MM/yyyy'}}</div>
    </div>
    <div fxFlex fxLayout="row" class="p-10">
      <div fxFlex="70"><strong>Cliente: </strong>{{this.debidaDiligencia?.cliente?.nombre}} /  {{this.debidaDiligencia?.cliente?.documento?.tipo}} {{this.debidaDiligencia?.cliente?.documento?.numero}}</div>
        <div fxFlex="30"><strong>Estado: </strong>{{this.debidaDiligencia?.estado}}</div>
    </div>

  </div>
</div>

<div fxLayout="column" fxFlex="100" >
  <div class="content" >

    <mat-tab-group dynamicHeight *ngFor="let dataSource of this.debidaDiligencia?.formulario?.sentencias">

      <mat-tab label="{{dataSource.nombre}}" >

          <sentencia-tree [dataSource]="dataSource" 
          [tablaDeEvaluacion]="debidaDiligencia?.tablaDeEvaluacion"
          [debidaDiligenciaEstado]="debidaDiligencia?.estado"
          [isResponsable]="false" 
          [printable] = "true"
          ></sentencia-tree>  
          
      </mat-tab>

  </mat-tab-group>

      <!-- <mat-tab-group dynamicHeight *ngFor="let dataSource of this.debidaDiligencia?.marcoDeReferencia?.sentencias">

          <mat-tab label="{{dataSource.nombre}}" >

              <div class="widget-group p-12" fxLayout="column wrap" fxFlex="100" *fuseIfOnDom>
                   <p>{{dataSource.descripcion}}</p>

                    <table mat-table [dataSource]="dataSource.sentencias" #mytable class="my-table mat-elevation-z8">

                      <ng-container matColumnDef="nombre">
                        <th mat-header-cell *matHeaderCellDef> Nombre. </th>
                        <td mat-cell *matCellDef="let element"> {{element.nombre}} </td>
                      </ng-container>

                      <ng-container matColumnDef="descripcion">
                        <th mat-header-cell *matHeaderCellDef> Descripción </th>
                        <td mat-cell *matCellDef="let element"> {{element.descripcion}} </td>
                      </ng-container>

                      <ng-container matColumnDef="respuesta">
                        <th mat-header-cell *matHeaderCellDef> Respuesta </th>
                        <td mat-cell *matCellDef="let element">
                          {{element.opcion?.nombre}} ({{element.opcion?.valor | number}})

                        </td>
                      </ng-container>

                      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
              </div>
          </mat-tab>
      </mat-tab-group> -->

  </div>
  <!-- TABS fin -->

</div>
<div mat-dialog-actions>
  <button mat-button (click)="printPdf()" [disabled]="disabled">{{'Imprimir' | translate}}</button>
  <button mat-button (click)="closeDialog()" mat-flat-button color="warn">{{'Cancel' | translate}}</button>
</div>
